module.exports = __webpack_public_path__ + "img/Metastasis-OVCA_10X_TIP.e600f491.png";